import * as z from 'zod/mini';
import * as l from './Gender.loc.js';
export const Gender = z.enum(['MALE', 'FEMALE', 'OTHER']);
export const GenderTranslation = (lang, gender) => l[gender](lang);
//# sourceMappingURL=Gender.js.map